import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { withRFSToken } from '../../../../Services/axios';

const DownloadGrid = ({ onClose, tabName }) => {

    const [formData, setFormData] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const exportToExcel = async () => {
        const payload = {
            ...formData,
            tab: tabName,
        };
        try {
            const res = await withRFSToken.post('vehicle-management/driver-visitor-download-excel', payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    },
                    responseType: 'blob', // important for handling binary file download like Excel
                }
            ).then(response => {
                // const blob = new Blob([response.data], { type: response.headers['content-type'] });
                // const url = window.URL.createObjectURL(blob);
                // const a = document.createElement('a');
                // a.href = url;
                // a.download = tabName + '-exported-data.xlsx';
                // document.body.appendChild(a);
                // a.click();
                // a.remove();

                const now = new Date();
                const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = formattedDateTime + ' Downloaded';
                document.body.appendChild(a);
                a.click();
                a.remove();
                onClose();
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    return (
        <>
            <Modal show onHide={onClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Download Filter ({tabName})</h3>
                    <p>Download the document as a selected option</p>
                    <div className='my-4 '>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                            type="date"
                            name="start_date"
                            value={formData.start_date || ''}
                            onChange={handleInputChange}
                        />
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                            type="date"
                            name="end_date"
                            value={formData.end_date || ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={exportToExcel}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DownloadGrid;